var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 201,
    viewBox: "0 0 770 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.025 47.5464C131.762 47.5464 155.877 71.1492 155.877 100.259C155.877 129.373 131.766 152.976 102.025 152.976C72.2891 152.976 48.1738 129.373 48.1738 100.263C48.1738 71.1492 72.2891 47.5464 102.025 47.5464Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.026 70.9866C118.535 70.9866 131.929 84.0916 131.929 100.259C131.929 116.427 118.539 129.532 102.026 129.536C85.5123 129.536 72.1226 116.427 72.1226 100.259C72.1226 84.0916 85.5123 70.9866 102.026 70.9866Z",
    fill: "#606CB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.851 176.958C59.6476 176.962 24.6115 142.723 24.6115 100.504C24.6074 58.281 59.6435 24.0461 102.847 24.0421C128.207 24.0421 150.744 35.8496 165.041 54.1323L185.987 41.3527C167.282 16.2897 137.008 0 102.843 0C46.0545 0 0 45.0052 0 100.504C0 155.999 46.0627 201 102.847 201C137.968 201 167.074 185.691 185.63 159.428L165.041 146.88C150.752 165.277 128.304 176.958 102.847 176.958H102.851Z",
    fill: "#45BDE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.721 81.7808C681.303 81.7808 679.245 72.1249 660.316 57.5598C606.684 27.8844 595.137 128.95 587.206 127.677C566.303 130.41 551.905 59.8497 549.448 53.5575L532.235 69.953C533.378 105.461 552.243 136.584 572.303 147.237C613.257 168.985 620.025 93.6371 628.753 85.4292C656.615 44.5646 667.45 123.666 703.727 104.599C725.825 92.9863 726.549 38.2399 753.324 33.9C751.782 25.3627 748.996 20.2175 746.873 11.5703C709.889 19.103 705.464 81.7808 692.721 81.7808Z",
    fill: "#45BDE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.921 48.9146H317.162V67.0397H243.066C237.991 67.0397 233.786 71.2447 233.786 76.3197V85.7448H299.037V103.87H233.641V150.415H215.661V76.3197C215.661 61.2396 227.841 48.9146 242.921 48.9146Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.871 132.288L417.086 132.433V150.558H365.611C360.536 150.558 355.751 149.398 351.401 147.223C345.02 144.033 339.8 138.813 336.755 132.433C334.58 128.083 333.42 123.298 333.42 118.223V49.0579H351.546V119.963C352.416 126.343 357.491 131.418 363.871 132.288Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M469.597 48.9146C497.583 48.9146 520.348 71.6797 520.348 99.6648C520.348 127.65 497.583 150.415 469.597 150.415C441.612 150.415 418.847 127.65 418.847 99.6648C418.847 71.6797 441.612 48.9146 469.597 48.9146ZM469.597 132.29C487.578 132.29 502.223 117.645 502.223 99.6648C502.223 81.6847 487.578 67.0397 469.597 67.0397C451.617 67.0397 436.972 81.6847 436.972 99.6648C436.972 117.645 451.617 132.29 469.597 132.29Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M769.266 6.83276L727.415 11.388L751.899 43.2747L769.266 6.83276Z",
    fill: "#45BDE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoFlow);
export default __webpack_public_path__ + "static/media/CoFlow.d68739b32ce67469bbe9e77e124b0b74.svg";
export { ForwardRef as ReactComponent };